module.exports = __webpack_public_path__ + "img/1596339906.77324bff.jpg";